import { isValidElement } from 'react'
import { Typography } from 'antd'
import { LinkOutlined } from '@ant-design/icons'
import { Conditional } from '@/components/Conditional'
import { isNotEmpty } from '@haina/utils-commons'

export const LineItem = ({ title, value, variant }) => {
  return (
    <div className={'flex justify-between items-start py-1 px-1'}>
      <Conditional
        condition={isNotEmpty(title)}
        whenTrue={
          <div className='w-24 text-left'>
            <Typography.Text type='secondary' className='after:content-[":"]'>{title}</Typography.Text>
          </div>
        }
        whenFalse={null}
      />
      <div className='w-full text-left'>
        <Conditional
          condition={variant === 'link'}
          whenTrue={
            <><LinkOutlined /> <a target='_blank' rel='noopener noreferrer' href={value}>{value}</a></>
          }
          whenFalse={isValidElement(value) ? value : <Typography.Text>{value ?? '-'}</Typography.Text>}
        />
      </div>
    </div>
  )
}